
import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { BarChart2, LinkIcon, AlertTriangle } from 'lucide-react';

interface CardLinkedPollsProps {
  linkedPolls: any[];
  isEditing: boolean;
  availablePolls: any[];
  isUsingAutomaticStats: boolean;
  isLoadingPolls: boolean;
  calculateStatsFromPolls: () => void;
}

const CardLinkedPolls: React.FC<CardLinkedPollsProps> = ({
  linkedPolls,
  isEditing,
  availablePolls,
  isUsingAutomaticStats,
  isLoadingPolls,
  calculateStatsFromPolls
}) => {
  return (
    <div className="space-y-2">
      {!isEditing && availablePolls.length > 0 && (
        <div className="flex items-center bg-blue-500/10 dark:bg-blue-950/30 p-3 rounded-md mb-2">
          <LinkIcon className="text-blue-500 dark:text-blue-400 mr-2" size={16} />
          <span className="text-sm text-blue-700 dark:text-blue-300">
            {availablePolls.length} active polls available. After creating this card, you can link it to polls for automatic statistics updates.
          </span>
        </div>
      )}
      
      {isEditing && linkedPolls.length > 0 && (
        <div className="flex items-center justify-between bg-blue-500/10 dark:bg-blue-950/30 p-3 rounded-md mb-2">
          <div className="text-sm">
            <span className="font-medium text-blue-700 dark:text-blue-300">This card is linked to {linkedPolls.length} poll(s).</span>
            <span className="ml-2 text-blue-600 dark:text-blue-400">You can calculate statistics automatically.</span>
          </div>
          <Button 
            type="button" 
            variant="outline" 
            size="sm"
            onClick={calculateStatsFromPolls}
            disabled={isLoadingPolls}
          >
            <BarChart2 size={16} className="mr-1" /> Calculate Stats
          </Button>
        </div>
      )}
      
      {isEditing && linkedPolls.length === 0 && (
        <div className="flex items-center bg-amber-500/10 dark:bg-amber-950/30 p-3 rounded-md mb-2">
          <AlertTriangle className="text-amber-500 dark:text-amber-400 mr-2" size={16} />
          <span className="text-sm text-amber-700 dark:text-amber-300">
            This card is not linked to any polls. Statistics must be entered manually.
          </span>
        </div>
      )}
      
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-medium text-foreground">Card Statistics</h3>
        {isUsingAutomaticStats && (
          <Badge variant="outline" className="bg-green-500/10 dark:bg-green-950/30 text-green-700 dark:text-green-300 border-green-200 dark:border-green-800">
            Auto-updated
          </Badge>
        )}
      </div>
    </div>
  );
};

export default CardLinkedPolls;
